/**
 * Autogenerated file don't modify
 */
(function () {
var tsBuild = (function (exports) {
    'use strict';

    var One = /** @class */ (function () {
        function One() {
        }
        One.init = function () {
            new One().run();
        };
        One.prototype.run = function () {
            One.initMeetingBoxes();
        };
        One.initMeetingBoxes = function () {
            var boxes = document.querySelectorAll('#meetingBoxes .boxTitle');
            for (var _i = 0, _a = Array.from(boxes); _i < _a.length; _i++) {
                var box = _a[_i];
                box.addEventListener('click', function (event) {
                    event.preventDefault();
                    var thisBox = event.currentTarget;
                    var boxContainer = thisBox.parentNode;
                    var open = boxContainer.classList.contains('open');
                    Array.from(document.querySelectorAll('.box'))
                        .forEach(function (b) { return b.classList.remove('open'); });
                    if (!open) {
                        boxContainer.classList.toggle('open');
                    }
                });
            }
        };
        return One;
    }());
    One.init();

    exports.One = One;

    return exports;

}({}));
typeof tsBuild === 'function' && tsBuild();})();
